import styled from 'styled-components'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'

const Wrapper = styled.div`
  width: 100%;
  position: relative;

  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #0a2790;

  .anticon {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`

const BackButton = ({ title, href = '' }) => {
  const navigate = useNavigate()

  return (
    <Wrapper>
      <ArrowLeftOutlined onClick={() => href ? navigate(href) : navigate(-1)} />
      {title}
    </Wrapper>
  )
}

export default BackButton
